// Auto-generated skeleton for Role

import { Person } from "./Person";

export const Role: Api.Role = {
  id: 0,
  hp_id: null,
  name: '',
  em: '',
  em_description: '',
  building_access: false,
  building_doctypes: false,
  building_doctypes_unlimited: false,
  building_roles: false,
  building_roles_unlimited: false,
  building_accounts: false,
  building_invoices: false,
  building_invoices_unlimited: false,
  cis_types: false,
  single_cis_types: null,
  unit_access: false,
  unit_doctypes: false,
  unit_doctypes_unlimited: false,
  unit_roles: false,
  unit_address_link: false,
  visibility_roles: false,
  faq_enabled: false,
  document_types: null,
  roles: null,
  permissions_count: 0,
  persons_count: 0,
  task_types: false,
  single_task_types: null,
  persons: [Person],
  created: null,
  updated: null,
};

